import { Component, forwardRef, Input, input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  imports: [FormsModule],
  standalone: true,
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CheckboxComponent),
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() ariaLabel?: string;
  name = input.required<string>();

  variant = input<'grey' | undefined>();

  value: any;
  touched = false;

  disabled = false;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange: (value: any) => void = (value: any) => {};

  onTouched = () => {};

  writeValue(value: any) {
    this.value = value;
    this.onChange!(this.value);
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  toggleValue() {
    if (!this.disabled) {
      this.writeValue(!this.value);
      this.markAsTouched();
    }
  }
}
